import getThemeOptions from './var'

export const themeOptions = (() => {
  let udColorList = filterUrlParams('tl')

  let ulColor = undefined
  let dlColor = undefined
  let udColor = undefined
  let ddColor = undefined

  udColorList?.forEach((colorStr) => {
    const item = colorStr.split('-')

    if (item.length !== 2) return

    const [type, color] = item

    if (type === 'ul') ulColor = `#${color}`
    else if (type === 'dl') dlColor = `#${color}`
    else if (type === 'ud') udColor = `#${color}`
    else if (type === 'dd') ddColor = `#${color}`
  })

  return getThemeOptions({ ulColor, dlColor, udColor, ddColor })
})()

const themeNames = Object.keys(themeOptions)

export function filterUrlParams(param) {
  const after = window.location.hash.split('?')[1]
  if (after) {
    const searchParams = new URLSearchParams(after)
    return searchParams.getAll(param)
  }
}

export function inserStyle() {
  let themeStyle = ''

  themeNames.forEach((theme) => {
    const themeItem = themeOptions[theme]
    const themeItemProps = Object.keys(themeItem)
    let themeStyleItem = ''
    themeItemProps.forEach((prop) => {
      themeStyleItem += `${prop}:${themeItem[prop]};`
    })
    themeStyle += `:root[data-theme='${theme}']{${themeStyleItem}}\n`
  })

  const styleTag = document.createElement('style')
  styleTag.innerHTML = themeStyle
  document.head.appendChild(styleTag)
}

// 判断系统是否为暗色
export const systemIsDark = () => {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function setTheme() {
  let themeName = filterUrlParams('theme')?.[0] || 'default'

  if (themeName === 'dark') themeName = 'default-d'
  else if (themeName === 'light') themeName = 'default-l'

  if (themeName === 'default') {
    themeName += systemIsDark() ? '-d' : '-l'
  }

  if (!themeNames.includes(themeName)) {
    themeName = themeNames[0]
  }
  document.querySelector('html').dataset.theme = themeName
  localStorage.setItem('THEME', themeName)
}

export function getTheme() {
  const themeName = localStorage.getItem('THEME')
  return themeOptions[themeName]
}
